import { useCallback } from 'react';
import { Button } from 'primereact/button';
import { Icon } from '@iconify/react';
import type { SaveIndicationResponse } from '../../../services/MedicalIndicationController';
import './SendIndicationPanel.scss';

interface SendIndicationPanelProps {
  result: SaveIndicationResponse;
  onNewIndication: () => void;
  onBack?: () => void;
}

export default function SendIndicationPanel({
  result,
  onNewIndication,
  onBack,
}: SendIndicationPanelProps) {
  const handlePrint = useCallback(() => {
    if (!result.encodedPdf) return;
    const blob = new Blob(
      [Uint8Array.from(atob(result.encodedPdf), (c) => c.charCodeAt(0))],
      { type: 'application/pdf' },
    );
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  }, [result.encodedPdf]);

  return (
    <div className="send-indication-panel">
      <div className="send-indication-panel__success">
        <span className="send-indication-panel__success-icon">
          <Icon icon="mdi:check-circle" style={{ fontSize: '2.5rem' }} />
        </span>
        <strong>Indicación médica guardada correctamente</strong>
        <small>El PDF ha sido generado y almacenado en la historia clínica del paciente.</small>
      </div>

      <div className="send-indication-panel__actions">
        <Button
          className="p-button-outlined send-indication-panel__btn"
          onClick={handlePrint}
          disabled={!result.encodedPdf}
        >
          <Icon icon="mdi:printer" style={{ fontSize: '1rem' }} />
          <span>Imprimir PDF</span>
        </Button>

        <Button
          className="p-button-outlined send-indication-panel__btn"
          onClick={onNewIndication}
        >
          <Icon icon="mdi:plus" style={{ fontSize: '1rem' }} />
          <span>Nueva indicación</span>
        </Button>

        {onBack ? (
          <Button
            className="p-button-outlined send-indication-panel__btn"
            onClick={onBack}
          >
            <Icon icon="mdi:arrow-left" style={{ fontSize: '1rem' }} />
            <span>Volver a historia clínica</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
}
